
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Icon 图标</h1>
<p>默认提供一套常用的图标。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>渲染后形式为<code>&lt;i class=&quot;m-icon m-icon-setting&quot;&gt;&lt;/i&gt;</code>的标签。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Icon type=&quot;setting&quot; size=&quot;24&quot; /&gt;
    &lt;Icon type=&quot;question-fill&quot; size=&quot;24&quot; /&gt;
    &lt;Icon type=&quot;home&quot; size=&quot;24&quot; /&gt;
&lt;/template&gt;
</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="icon-tu-biao" class="anchor-title">Icon 图标 <a class="header-anchor" href="#icon-tu-biao">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>图标名称</td>
<td>-</td>
</tr>
<tr>
<td>size</td>
<td>String, Number</td>
<td>图标字体大小</td>
<td>-</td>
</tr>
<tr>
<td>color</td>
<td>String</td>
<td>图标字体颜色</td>
<td>-</td>
</tr>
<tr>
<td>customIcon</td>
<td>String</td>
<td>自定义图标名称</td>
<td>-</td>
</tr>
</tbody>
</table>
<h2 id="suo-you-tu-biao" class="anchor-title">所有图标 <a class="header-anchor" href="#suo-you-tu-biao">#</a></h2>
<p><icon-list></icon-list></p>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Icon',{attrs:{"type":"setting","size":"24"}}),_vm._v(" "),_c('Icon',{attrs:{"type":"question-fill","size":"24"}}),_vm._v(" "),_c('Icon',{attrs:{"type":"home","size":"24"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  